module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-green-cf5f9102af5855938b06bae95dead9e0.jpg";